import React from 'react'
import { CustomTabs } from 'components/atoms/AppTabs/AppTabs'
import { useOperationModes } from 'core/hooks/useOperationModes'
import { TemplateOperationMode } from '../../../../domain/entities/Template'

interface TemplateTabsProps {
    activeTab: string
    totalAllTemplates: number
    totalByClassificationType: TemplateOperationMode[]
    onTabChange: (tabId: string) => void
}

export function TemplateTabs({
    activeTab,
    totalAllTemplates,
    totalByClassificationType,
    onTabChange,
}: TemplateTabsProps) {
    const { operationModes } = useOperationModes()

    const tabs = [
        { id: 'all', label: 'Todos', count: totalAllTemplates },
        ...operationModes.map((type) => {
            const apiData = totalByClassificationType.find(t => t.id === type.id)
            return {
                id: type.id.toString(),
                label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
                count: apiData ? parseInt(apiData.total, 10) : 0,
            }
        }),
    ]

    return (
        <CustomTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            containerClassName="bg-[#F1F5F9] rounded-[6px] p-1 gap-1"
            className=""
            activeClassName="text-[#070A13] bg-[#fff] rounded-[4px]"
            inactiveClassName="text-[#64748B] hover:text-[#070A13] bg-transparent"
        />
    )
}
